import { Route } from "@angular/router";
import { EnrichmentEditPackage } from "@app/feature/management/enrichment/components/edit/enrichment-edit-package/enrichment-edit-package";
import { Enrichment } from "app/feature/management/enrichment/enrichment";
import { APP_ROUTES } from "@shared/constants/app-routes.constants";
import { enrichmentDirtyGuard } from "@app/feature/management/enrichment/guards/enrichment-dirty.guard";
import {
  channelLinkGuard,
  enrichmentLinkScope,
} from "@app/feature/management/enrichment/services/channel-link/channel-link.guard";
import { editPackageMatcher } from "@app/feature/management/enrichment/services/edit-package-url";

export const enrichmentPriceRoutes: Route[] = [
  {
    path: "",
    component: Enrichment,
  },
  {
    matcher: editPackageMatcher,
    component: EnrichmentEditPackage,
    // The editor works on one channel: the one its link names (`?channel=`).
    canActivate: [
      channelLinkGuard({
        listUrl: APP_ROUTES.MANAGEMENT.ENRICHMENT_PRICE.ROOT,
        scope: enrichmentLinkScope,
      }),
    ],
    canDeactivate: [enrichmentDirtyGuard],
    // Load-bearing, so stated rather than defaulted: the guards run again
    // when `:popId` changes (the unsaved-edits prompt covers a price switch)
    // and not on a `?channel=` rewrite.
    runGuardsAndResolvers: "paramsChange",
  },
];
